import { registerChatKitElement } from "./ChatKitElement"

registerChatKitElement()
